<script setup>
import InfoIconProfile from '@/components/svg/InfoIconProfile.vue'

defineProps({
  text: { type: String, required: true },
})
</script>

<template>
  <div class="info-notice">
    <InfoIconProfile class="info-notice__icon" />
    <p class="info-notice__text" v-html="text" />
  </div>
</template>

<style scoped lang="scss">
.info-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px 0;

  &__icon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }

  &__text {
    margin: 0;
    color: #726ce7;
    font-size: 14px;
    line-height: 1.5;
  }

  @media screen and (max-width: 1023px) {
    gap: 8px;
    margin-bottom: 12px;

    &__text {
      font-size: 13px;
    }
  }
}
</style>
